import { Button } from '../catalyst/button';
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../catalyst/dialog';
import { ErrorMessage, Field } from '../catalyst/fieldset';
import Spinning from '../components/spinning';

export default function ConfirmationModel({open, setIsOpen, title, description, buttonText, submitting, confirmationAction, errResponse}) {

  return (
    <>
      <Dialog open={open} onClose={setIsOpen}>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>
                {description}
        </DialogDescription>
        <DialogBody>
          {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setIsOpen(false)}>
            Cancel
          </Button>

          <Button onClick={() => {confirmationAction()}} className="w-full" disabled={submitting}>
                        {submitting ? <Spinning /> : buttonText}
            </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
